import { render } from "./InstructionView.vue?vue&type=template&id=17107b2a"
import script from "./InstructionView.vue?vue&type=script&lang=js"
export * from "./InstructionView.vue?vue&type=script&lang=js"

import "./InstructionView.vue?vue&type=style&index=0&id=17107b2a&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__